module.exports = __webpack_public_path__ + "img/img1-1.5df7ec6e.png";